import React, { useState, useEffect, useRef } from 'react';
import './ScanningScreen.css';

function ScanningScreen({ isTracking, isRecording, onStartRecording, onStopRecording }) {
  const [textVisible, setTextVisible] = useState(true);
  const timeoutRef = useRef(null);

  useEffect(() => {
    // Clear any existing timeout when tracking status changes
    clearTimeout(timeoutRef.current);

    if (isTracking) {
      // When tracking starts, show the text
      setTextVisible(true);
      // Set a timeout to hide the text after 1 second
      timeoutRef.current = setTimeout(() => {
        setTextVisible(false);
      }, 1000);
    } else {
      // If not tracking, always show the text
      setTextVisible(true);
    }

    // Cleanup the timeout when the component unmounts
    return () => clearTimeout(timeoutRef.current);
  }, [isTracking]);

  return (
    <div className="scanning-overlay">
      {/* Text container positioned at the bottom-center */}
      {textVisible && (
        <div className="scanning-text-container">
          <p className={`scanning-text ${isTracking ? 'tracking' : ''}`}>
            {isTracking ? '¡Marcador detectado!' : 'Apunta la cámara al marcador'}
          </p>
        </div>
      )}

      {/* Record button container positioned at the bottom-right */}
      {isTracking && (
        <div className="record-controls">
          {isRecording ? (
            <button
              type="button"
              className="record-btn record-btn-stop"
              onClick={onStopRecording}
              aria-label="Detener grabación"
            >
              <span className="record-dot" />
            </button>
          ) : (
            <button
              type="button"
              className="record-btn record-btn-start"
              onClick={onStartRecording}
              aria-label="Grabar pantalla"
            >
              <span className="record-icon" />
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default ScanningScreen;
